'use client';

import React, { type ReactNode } from 'react';
import { WagmiProvider } from 'wagmi';
// import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
// import { AppKitNetwork, mainnet } from '@reown/appkit/networks';
import { createAppKit } from '@reown/appkit/react';
import { wagmiAdapter, projectId, networks } from './config';

const metadata = {
  name: process.env.NEXT_PUBLIC_REOWN_PROJECT_NAME!,
  description: process.env.NEXT_PUBLIC_REOWN_PROJECT_DESCRIPTION!,
  url: process.env.NEXT_PUBLIC_REOWN_PROJECT_DOMAIN!,
  icons: [],
};

export const modal = createAppKit({
  adapters: [wagmiAdapter],
  projectId,
  networks,
  metadata,
  themeMode: 'dark',
  features: {
    analytics: true,
    email: false,
    socials: false,
    history: false,
    //       swaps: false,
  },
});

// let wagmiAdapter: WagmiAdapter;
//
// function getWagmiAdapter(projectId: string, projectName: string, projectDescription: string, projectUrl: string) {
//   if (wagmiAdapter) return wagmiAdapter;
//   const networks = [mainnet] as [AppKitNetwork, ...AppKitNetwork[]];
//   wagmiAdapter = new WagmiAdapter({
//     networks,
//     projectId,
//     ssr: true,
//   });
//
//   createAppKit({
//     adapters: [wagmiAdapter],
//     networks,
//     metadata: {
//       name: projectName,
//       description: projectDescription,
//       url: projectUrl,
//       icons: [],
//     },
//     projectId,
//     features: {
//       socials: false,
//       email: false,
//       history: false,
//       swaps: false,
//       analytics: false,
//     },
//   });
//   return wagmiAdapter;
// }

export function AppKit({
  children,
  // projectId,
  // projectName,
  // projectDescription,
  // projectUrl,
}: {
  children: ReactNode;
  projectId: string;
  projectName: string;
  projectDescription: string;
  projectUrl: string;
}) {
  // const wagmiAdapter = getWagmiAdapter(projectId, projectName, projectDescription, projectUrl);

  return <WagmiProvider config={wagmiAdapter.wagmiConfig}>{children}</WagmiProvider>;
}
